/**
 * Icon name registry — single source of truth for all allowed icon names.
 *
 * Application code must only reference icons that exist in this registry.
 * To add a new icon: add its name here, then create a matching def file
 * in `defs/` and re-export it from `defs/index.ts`.
 */

export const iconNames = [
  'add',
  'adjusting',
  'alcohol',
  'alert',
  'attach',
  'backward',
  'backward-10s',
  'bar-graph',
  'beaker-filled',
  'beaker-outlined',
  'beer',
  'blow',
  'bolt',
  'bolt-filled',
  'bookmark',
  'books',
  'bubble-speech',
  'calendar',
  'calendar-time',
  'camera',
  'cannabis',
  'care',
  'chart',
  'check',
  'chewing-tobacco',
  'cigarette',
  'clock',
  'close',
  'coffee',
  'coin',
  'compass',
  'computer',
  'corporate',
  'cup',
  'delivery',
  'detach',
  'document',
  'down-arrow',
  'down-chevron',
  'download',
  'dropdown',
  'edit',
  'emotions',
  'exit',
  'expand',
  'eye-closed',
  'eye-open',
  'facebook',
  'finish-flag',
  'flag',
  'flip-video',
  'forward',
  'forward-10s',
  'gift',
  'growth',
  'hamburger-menu',
  'happy',
  'happy-filled',
  'health-filled',
  'health-outlined',
  'heart',
  'heart-filled',
  'home-filled',
  'home-outlined',
  'hourglass',
  'info',
  'journey',
  'keyboard',
  'left-arrow',
  'left-chevron',
  'library-filled',
  'library-outlined',
  'lightbulb',
  'linkedin',
  'liquor',
  'loading',
  'lock',
  'lungs',
  'mail',
  'medication-bottle',
  'message-filled',
  'message-outlined',
  'mic',
  'mic-off',
  'mind',
  'minus',
  'money',
  'multi-document',
  'no-internet',
  'no-sound',
  'no-video',
  'notification',
  'okay',
  'okay-filled',
  'open',
  'open-new-window',
  'open-window',
  'opioid',
  'pair-bluetooth',
  'pause',
  'pelatoken',
  'pen',
  'phone',
  'piggy-bank',
  'pin',
  'play',
  'play-circle',
  'plus',
  'prescription',
  'profile',
  'profile-filled',
  'profile-outlined',
  'prohibited',
  'question',
  'radar',
  'really-happy',
  'really-happy-filled',
  'really-sad',
  'really-sad-filled',
  'refresh',
  'reverse-camera',
  'ribbon',
  'right-arrow',
  'right-chevron',
  'sad',
  'sad-filled',
  'search',
  'send',
  'settings',
  'share',
  'shield',
  'smartphone',
  'soundwave',
  'speaker',
  'speedometer',
  'star',
  'star-filled',
  'stats-filled',
  'stats-outlined',
  'status-dot',
  'stethoscope',
  'stimulants',
  'stop',
  'sun',
  'synergy',
  'target',
  'thumbs-down',
  'thumbs-up',
  'thumbs-up-strong',
  'tick',
  'tick-with-container',
  'tick-with-outlined-container',
  'together',
  'toolbox',
  'top-arrow',
  'trash',
  'trigger',
  'trophy',
  'twitter',
  'unlock',
  'up-chevron',
  'vape',
  'video',
  'video-outlined',
  'warning',
  'wave',
  'whistle',
  'wine',
  'youtube',
] as const;

export type IconName = (typeof iconNames)[number];

/** Lookup set for runtime validation of icon names. */
export const iconNameSet: ReadonlySet<string> = new Set(iconNames);
